<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.092"
      height="14.192"
      viewBox="0 0 10.092 14.192"
      class="scaling-svg"
    >
      <g transform="translate(0 -0.193)">
        <path
          d="M2.328,4.656A2.328,2.328,0,1,1,4.656,2.328,2.331,2.331,0,0,1,2.328,4.656Zm0-3.1a.776.776,0,1,0,.776.776A.777.777,0,0,0,2.328,1.552Z"
          transform="translate(2.718 0.192)"
        />
        <path
          d="M.445.055a.721.721,0,0,1,.786.156L4.114,3.094A.721.721,0,0,1,3.094,4.114L1.442,2.461V8.65A.721.721,0,0,1,0,8.65V.721A.721.721,0,0,1,.445.055Z"
          transform="translate(5.767 5.014)"
        />
        <path
          data-name="Path"
          d="M3.88.055a.721.721,0,0,1,.445.666V8.65a.721.721,0,0,1-1.442,0V2.461L1.231,4.114A.721.721,0,0,1,.211,3.094L3.094.211A.721.721,0,0,1,3.88.055Z"
          transform="translate(0 5.014)"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class PersonIcon extends Vue {}
</script>

<style>
</style>
